export const WILLIE_BRAND_COLOR = '#32cbff'
export const L_TO_M3 = 0.001

export const COLORS = [
  'yellow',
  'violet',
  'tomato',
  'teal',
  'sky',
  'ruby',
  'red',
  'purple',
  'plum',
  'pink',
  'orange',
  'mint',
  'lime',
  'jade',
  'iris',
  'indigo',
  'green',
  'gray',
  'grass',
  'gold',
  'cyan',
  'crimson',
  'brown',
  'bronze',
  'blue',
  'amber',
  'gray'
] as const
